"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * Tableau Services APIs
 * Open API specification for Tableau Services APIs
 *
 * The version of the OpenAPI document: latest
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
const runtime_1 = require("../runtime");
const _1 = require("./");
function TableauNlpRefinementuiEntitySearchResponseFromJSON(json) {
    return TableauNlpRefinementuiEntitySearchResponseFromJSONTyped(json, false);
}
exports.TableauNlpRefinementuiEntitySearchResponseFromJSON = TableauNlpRefinementuiEntitySearchResponseFromJSON;
function TableauNlpRefinementuiEntitySearchResponseFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'matchedQuery': !runtime_1.exists(json, 'matched_query') ? undefined : json['matched_query'],
        'unmatchedQuery': !runtime_1.exists(json, 'unmatched_query') ? undefined : json['unmatched_query'],
        'customSuggestionEntities': !runtime_1.exists(json, 'custom_suggestion_entities') ? undefined : (json['custom_suggestion_entities'].map(_1.TableauNlpRefinementuiCustomSuggestionEntityFromJSON)),
        'valueEntities': !runtime_1.exists(json, 'value_entities') ? undefined : (json['value_entities'].map(_1.TableauNlpRefinementuiValueEntityFromJSON)),
        'fieldEntities': !runtime_1.exists(json, 'field_entities') ? undefined : (json['field_entities'].map(_1.TableauNlpRefinementuiFieldEntityFromJSON)),
        'conceptEntities': !runtime_1.exists(json, 'concept_entities') ? undefined : (json['concept_entities'].map(_1.TableauNlpRefinementuiConceptEntityFromJSON)),
        'responseHeaders': !runtime_1.exists(json, 'response_headers') ? undefined : _1.TableauMicroservicesGatewayCommonV1HttpResponseHeadersFromJSON(json['response_headers']),
    };
}
exports.TableauNlpRefinementuiEntitySearchResponseFromJSONTyped = TableauNlpRefinementuiEntitySearchResponseFromJSONTyped;
function TableauNlpRefinementuiEntitySearchResponseToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'matched_query': value.matchedQuery,
        'unmatched_query': value.unmatchedQuery,
        'custom_suggestion_entities': value.customSuggestionEntities === undefined ? undefined : (value.customSuggestionEntities.map(_1.TableauNlpRefinementuiCustomSuggestionEntityToJSON)),
        'value_entities': value.valueEntities === undefined ? undefined : (value.valueEntities.map(_1.TableauNlpRefinementuiValueEntityToJSON)),
        'field_entities': value.fieldEntities === undefined ? undefined : (value.fieldEntities.map(_1.TableauNlpRefinementuiFieldEntityToJSON)),
        'concept_entities': value.conceptEntities === undefined ? undefined : (value.conceptEntities.map(_1.TableauNlpRefinementuiConceptEntityToJSON)),
        'response_headers': _1.TableauMicroservicesGatewayCommonV1HttpResponseHeadersToJSON(value.responseHeaders),
    };
}
exports.TableauNlpRefinementuiEntitySearchResponseToJSON = TableauNlpRefinementuiEntitySearchResponseToJSON;
